import { render } from "./AddReader.vue?vue&type=template&id=2c103728&scoped=true"
import script from "./AddReader.vue?vue&type=script&lang=js"
export * from "./AddReader.vue?vue&type=script&lang=js"

import "./AddReader.vue?vue&type=style&index=0&id=2c103728&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c103728"]])

export default __exports__